import { useRecoilValue } from 'recoil';

import { AlertsHeadlinesState, userSettingsState } from '@store';

export const useAlertTrigger = (alertsState: AlertsHeadlinesState, prevent = false) => {
  const { appAccessed } = useRecoilValue(userSettingsState);

  // Do not override any modal user actions
  // Also check valid data
  if (prevent || !alertsState || !alertsState.alertOverlays || alertsState.alertOverlays.length === 0 || !appAccessed) {
    return null;
  }

  const activeAlert = alertsState.alertOverlays[0];
  const { identifier } = activeAlert;

  const lastAlerts = alertsState.shownAlerts;

  // Already shown the alert, no need to re-show it
  if (lastAlerts.includes(identifier)) {
    return null;
  }

  return activeAlert;
};
